package network

import features.BaseViewModel
import kotlinx.coroutines.Job
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch

/**
 * Observa el estado de conexión con Firebase Realtime Database.
 * Usa el nodo especial .info/connected que Firebase mantiene automáticamente.
 */
class ConexionViewModel : BaseViewModel() {

    private val _estaConectado = MutableStateFlow(true) // Asumimos conectado al inicio
    val estaConectado: StateFlow<Boolean> = _estaConectado.asStateFlow()

    private var observerJob: Job? = null

    fun iniciarMonitoreo() {
        if (observerJob?.isActive == true) return
        observerJob = viewModelScope.launch {
            try {
                val db = FirebaseClient.database
                db.reference(".info/connected").valueEvents.collect { snap ->
                    val conectado = try { snap.value<Boolean>() } catch (e: Exception) { true }
                    _estaConectado.value = conectado
                }
            } catch (e: Exception) {
                // Si falla la suscripción, asumimos desconectados
                _estaConectado.value = false
            }
        }
    }

    fun detener() {
        observerJob?.cancel()
        observerJob = null
    }
}
